import { ISnowplowContext } from "@/services/DTOs/SnowplowContext";

export interface IServicesContextSchema {
  schema: string;
  data: IServicesSnowplowContextData;
}

export interface IServicesSnowplowContextData {
  personServices?: string;
  organizationServices?: string;
}

export class ServicesSnowplowContext implements ISnowplowContext {
  public schemaName: string;
  public personServices?: string;
  public organizationServices?: string;

  constructor(data: IServicesSnowplowContextData, schemaName: string = "ServicesContext") {
    this.schemaName = schemaName;
    this.personServices = data.personServices;
    this.organizationServices = data.organizationServices;
  }

  public parseSchema(id: string): IServicesContextSchema {
    const { personServices, organizationServices } = this;
    return {
      schema: id,
      data: { personServices, organizationServices } as IServicesSnowplowContextData
    };
  }
}
